import { Loading } from '@/pages/time-off-calendar/admin/admin-calendar.loading';

export default Loading;
